import './Header.scss'
import React from 'react'

import { ReactComponent as Logo } from '../../assets/logoBenGibert_filled.svg'
import { ReactComponent as Malt } from '../../assets/malt.svg'
import { ReactComponent as Linkedin } from '../../assets/linkedin.svg'
import { ReactComponent as Github } from '../../assets/github.svg'

function Header() {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    return (
        <header className="header">
            <nav className="header__nav" aria-label="Navigation principale">
                <div className="header__nav-left">
                    <button
                        type="button"
                        className="header__logo-button"
                        onClick={scrollToTop}
                        aria-label="Retour en haut de la page"
                    >
                        <Logo
                            className="header__logo"
                            aria-hidden="true"
                            focusable="false"
                        />
                    </button>

                    <ul className="header__social" aria-label="Réseaux sociaux">
                        <li>
                            <a
                                href="https://www.malt.fr/profile/benjamingibert"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Voir le profil Malt de Benjamin Gibert, s’ouvre dans un nouvel onglet"
                            >
                                <Malt
                                    className="header__social-icon"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.linkedin.com/in/bengibert"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Voir le profil LinkedIn de Benjamin Gibert, s’ouvre dans un nouvel onglet"
                            >
                                <Linkedin
                                    className="header__social-icon"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://github.com/benngvolt"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Voir le profil GitHub de Benjamin Gibert, s’ouvre dans un nouvel onglet"
                            >
                                <Github
                                    className="header__social-icon"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                            </a>
                        </li>
                    </ul>
                </div>

                <a
                    className="header__mailto"
                    href="mailto:contact@benjamingibert.com"
                    aria-label="Envoyer un email à Benjamin Gibert"
                >
                    <span aria-hidden="true">ME CONTACTER</span>
                </a>
            </nav>
        </header>
    )
}

export default Header